/**
 * Created by ianandersen on 4/5/17.
 */

import React from 'react';

class SeriesItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.id,
      title: props.title,
      href: '/series/' + props.id,
      coverImage: props.image
    };
  }

  render() {
    return (
      <div key={this.state.id}>
        <a href={this.state.href}>
          <p style={{marginBottom: 2, marginTop: 20}}>{this.state.title}</p>
          {this.state.coverImage ? (
            <img
              style={{maxWidth: 200, maxHeight: 100}}
              alt={this.state.title + ' Series'}
              src={
                this.state.coverImage.helper
                  ? this.state.coverImage.helper.featuredUrl()
                  : null
              }
            />
          ) : null}
        </a>
      </div>
    );
  }
}

export default SeriesItem;
